import { render, staticRenderFns } from "./CustomAttributeFileUpload.vue?vue&type=template&id=02221fd8&scoped=true&"
import script from "./CustomAttributeFileUpload.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributeFileUpload.vue?vue&type=style&index=0&id=02221fd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02221fd8",
  null
  
)

export default component.exports